import React, { useEffect, useState, useRef } from "react";
import { BASE_URL } from "../../../constants";
import { Link } from "react-scroll";
import { Link as DomLink, useNavigate } from "react-router-dom";
import { Button } from "@mui/base";
import { useDispatch, useSelector } from "react-redux";
import { resetsignupState } from "../../../redux/signupSlice";
import { resetloginState } from "../../../redux/loginSlice";


import Swal from "sweetalert2";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userToken = useSelector((s) => s.login.data.token);
  const [checkStatus, setCheckStatus] = useState(false);
  const [activeNav, setActiveNav] = useState("HOME");
  const navRef = useRef();
  const collapseNavbar = () => {
    if (navRef.current?.classList.contains("show")) {
      navRef.current.classList.remove("show");
    }
  };

  const signupRoute = () => {
    navigate("/signup");
  };
  const home = () => {
    navigate("/");
  };

  const loginRoute = () => {
    navigate("/login");
  };

  const footer = () => {
    navigate("/footer");
  };

  const handleLogout = () => {
    setCheckStatus(false);
    dispatch(resetsignupState());
    dispatch(resetloginState());
    navigate("/");
  };

  useEffect(() => {
    if (userToken) {
      setCheckStatus(true);
    } else {
      setCheckStatus(false);
    }
  }, [userToken]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);
  const logout = () => {
    if (
      Swal.fire({
        position: "top",
        title: "Are you sure?",
        text: "You are about to logout from CommutersLink",
        // // icon: 'warning',
        showCancelButton: true,
        // confirmButtonColor: 'green',
        cancelButtonColor: "swal-custom",
        confirmButtonText: "Logout",
        cancelButtonText: "Cancel",
        customClass: {
          confirmButton: "swal-custom",
          cancelButton: "swal-custom",
          htmlContainer: "text-center",
        },
        // cancelClass:{

        //   cancelButton: 'swal-custom',
        // }
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(resetsignupState());
          dispatch(resetloginState());
          navigate("/login");
        }
      })
    ) {
    }
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          {!checkStatus ? (
            <div className="pos-f-t">
              <nav className="navbar navbar-expand-lg navbar-dark fixed-top"
                            style={{ backgroundColor: "#01183F" }}>
                <DomLink
                  className="navbar-brand p-2"
                  style={checkStatus ? { pointerEvents: "none" } : null}
                  to="/"
                >
                  <img
                    src={`${BASE_URL}/assets/images/logo.png`}
                    width="mr-auto"
                    height="50px"
                    alt="logoimg"
                  />
                </DomLink>
                <button
                  className="navbar-toggler mr-2 d-lg-none" // Add 'd-lg-none' class to hide the button in desktop view
                  style={{
                    color: "#FFc738",
                    width: "40px",
                    height: "35px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" style={{}}></span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                  ref={navRef}
                >
                  <ul className="navbar-nav ml-auto">
                    <li className="nav-item nav-grey">
                      <Link
                         className={`nav-link mr-3 ml-3 fw-bold fs-6 ${
    activeNav === "HOME" ? "active-nav" : ""
  }`}
                        style={checkStatus ? { pointerEvents: "none" } : null}
                        // to="carousel"
onClick={() => {
  setActiveNav("HOME");

  if (window.location.pathname == "/") {
    window.scrollTo(0, 0);
  }

  home();
  collapseNavbar();
}}
                      >
                        HOME
                      </Link>
                    </li>
                    <li className="nav-item nav-grey">
<Link
  className={`nav-link mr-3 ml-3 fw-bold fs-6 ${
    activeNav === "CONCEPT" ? "active-nav" : ""
  }`}
  to="costEarningSection"
  style={checkStatus ? { pointerEvents: "none" } : null}
  onClick={() => {
    setActiveNav("CONCEPT");

    if (window.location.pathname !== "/") {
      home();
    }

    collapseNavbar();
  }}
  smooth={true}
  offset={20}
  duration={500}
>
  CONCEPT
</Link>
                    </li>
                    <li className="nav-item nav-grey">
                      <Link
className={`nav-link mr-3 ml-3 fw-bold fs-6 ${
  activeNav === "HOW" ? "active-nav" : ""
}`}
                        style={checkStatus ? { pointerEvents: "none" } : null}
                        to="howworks"
                        onClick={() => {
                          setActiveNav("HOW");
                          home();
                          collapseNavbar();
                        }}
                        offset={20}
                        duration={50}
                      >
                        HOW IT WORKS?
                      </Link>
                    </li>
                    <li className="nav-item nav-grey">
                      <Link
className={`nav-link mr-3 ml-3 fw-bold fs-6 ${
  activeNav === "IMPACT" ? "active-nav" : ""
}`}
                        style={checkStatus ? { pointerEvents: "none" } : null}
                        to="contribute"
                        smooth="true"
                        onClick={() => {
                          setActiveNav("IMPACT");
                          home();
                          collapseNavbar();
                        }}
                        offset={20}
                        duration={50}
                      >
                        IMPACT
                      </Link>
                    </li>
                    <li className="nav-item nav-grey">
                      <DomLink
                        className={`nav-link mr-3 ml-3 fw-bold fs-6 ${
  activeNav === "FAQS" ? "active-nav" : ""
}`}
                        style={checkStatus ? { pointerEvents: "none" } : null}
                        to="/Faq"
                        onClick={() => {
                          setActiveNav("FAQS");
                          collapseNavbar();
                        }}
                      >
                        FAQS
                      </DomLink>
                    </li>
                    <li className="nav-item nav-grey">
                      <Link
className={`nav-link mr-3 ml-3 fw-bold fs-6 ${
  activeNav === "CONTACT" ? "active-nav" : ""
}`}
                        style={checkStatus ? { pointerEvents: "none" } : null}
                        to="contact"
                        onClick={() => {
                          setActiveNav("CONTACT");
                          home();
                          collapseNavbar();
                        }}
                        smooth="true"
                        offset={20}
                        duration={50}
                      >
                        CONTACT
                      </Link>
                    </li>
                  </ul>

                  <div>
                    {/* <button
                    className="btn-custom mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold"
                    onClick={signupRoute}
                    disabled={checkStatus}
                  >
                    Sign up
                  </button> */}

                    {/* <button
                      className="btn-custom1 mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold fs-6"
                      onClick={() => {
                        loginRoute();
                        collapseNavbar();
                      }}
                      //disabled={checkStatus}
                    >
                      Login
                    </button> */}
                  </div>
                </div>
              </nav>
            </div>
          ) : (
            <div className="pos-f-t">
              <nav
className="navbar navbar-expand-lg fixed-top justify-content-between"
  style={{ backgroundColor: "#01183F" }}
>
                <DomLink
                  className="navbar-brand p-2"
                  style={checkStatus ? { pointerEvents: "none" } : null}
                  to="/"
                >
                  <img
                    src={`${BASE_URL}/assets/images/logo.png`}
                    width="mr-auto"
                    height="50px"
                    alt="logoimg"
                  />
                </DomLink>
                {/* <button
                className="navbar-toggler mr-2 d-lg-none" // Add 'd-lg-none' class to hide the button in desktop view
                style={{
                  color: '#198754',
                  width: '40px',
                  height: '35px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" style={{}}></span>
              </button> */}
                {/* <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
                ref={navRef}
              > */}
                <div>
                  {/* <button
                    className="btn-custom mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold"
                    onClick={signupRoute}
                    disabled={checkStatus}
                  >
                    Sign up
                  </button> */}

                  <button
                    className="btn-custom1 mx-2 border-0 px-4 py-2 rounded rounded-2 text-white fw-bold fs-6"
                    onClick={() => {
                      logout();
                    }}
                  //disabled={checkStatus}
                  >
                    Logout
                  </button>
                </div>
                {/* </div> */}
              </nav>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
